module.exports = __webpack_public_path__ + "img/aej1n-66wvl.032.2a4cab80.png";